import { useEffect, useRef, useState } from "react";
import { FiltersManager } from "../../../../components/FiltersManager/FiltersManager";
import { NavBar } from "../../../../components/NavBar/NavBar";
import "./discrepancy.scss";
import { SortingButton } from "../../../../components/Sorting/SortingButton";
import { SortingProvider } from "../../../../contexts/SortingContext";
import { DiscrepancyItem } from "./DiscrepancyItem/DiscrepancyItem";
import { FiltersAndSorting } from "../../../../components/FiltersAndSorting/FiltersAndSorting";
import { getDiscrepancySvc } from "../../Services/DiscrepancyServices";
import { environment } from "../../../../environments/environment";
import { HTTP_RESPONSE_CODES } from "../../../../globals/globals";
import Skeleton from "react-loading-skeleton";
import { ResultsNotFound } from "../../../../components/ResultsNotFound/ResultsNotFound";
import { useDispatch } from "react-redux";
import { addTab } from "../../../../redux/features/TabsManager/tabSlice";

export const Discrepancy = () => {
  const isFirstRender = useRef(true);

  const getCompanyFilter = () => {
    let companiesId = JSON.parse(localStorage.getItem("u_companies")).map(
      (e) => {
        return e.id;
      }
    );
    return {
      columnName: "companyId",
      value: companiesId,
    };
  };

  const buildFilterBody = (filters = []) => {
    const filtered = filters.filter(
      (item) => item && item.columnName !== "company_id"
    );

    return [getCompanyFilter(), ...filtered];
  };
  const [orderParameter, setOrderNumberParam] = useState(() => {
    const company = [{
      columnName : "companyId",
      value : [JSON.parse(localStorage.getItem("u_company_id"))]
    }];

    return company;
  });
  const [viewFilters, setViewFilters] = useState(false);
  const [sortingProperties, setSortingProperties] = useState({
    id: "Discrepancy Number",
    orderType: "Order Type",
    orderNumber: "Order Number",
    line: "Line Number",
    location: "Location",
    supplyChain: "Supply Chain User",
    createdBy: "Discrepancy Creator",
    status: "Status",
  });
  const [filtersDefinition, setFiltersDefinition] = useState([
    {
      id: 143,
      columnName: "id",
      isDate: false,
      columnSelection: "id",
    },
    {
      id: 112,
      columnName: "orderType",
      isDate: false,
      columnSelection: "id",
    },
    {
      id: 144,
      columnName: "orderNumber",
      isDate: false,
      columnSelection: "id",
      parameters: orderParameter,
    },
    {
      id: 87,
      columnName: "location",
      isDate: false,
      columnSelection: "code",
    },
    {
      id: 142,
      columnName: "status",
      isDate: false,
      columnSelection: "status",
      preselectValues: ["Sent to Vendor", "Reviewed", "Pending Review"],
    },
  ]);
  const [sortingColumnsFilters, setSortingColumnsFilters] = useState({
    orderType: 112,
    location: 87,
    orderNumber: 144,
    status: 142,
    id: 143,
  });
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(15);
  const [maxPages, setMaxPages] = useState(0);
  const [sorting, setSorting] = useState("id");
  const [body, setBody] = useState(buildFilterBody());
  const [loading, setLoading] = useState(false);
  const [discrepancyList, setDiscrepancyList] = useState([]);
  const [visualizeSkeletonLoading, setVisualizeSkeleton] = useState(true);
  const dispatch = useDispatch()

  // 
  const getDiscrepancyList = async (
    p = page,
    ps = pageSize,
    searchValue = search,
    sort = sorting,
    isScroll = false,
    filters = body
  ) => {
    setLoading(true);
    try {
      let request = await getDiscrepancySvc(p, ps, searchValue, sort, filters);
      if (request.data.responseCode == HTTP_RESPONSE_CODES.SUCCESS) {
        setMaxPages(request.data.totalPages);
        if (!isScroll) {
          setDiscrepancyList(request.data.load);
          setPage(1);
        } else {
          setDiscrepancyList((prev) => {
            return [...prev, ...request.data.load];
          });
          setPage((prev) => prev + 1);
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const discrepanciesSectionReference = useRef(null);

  const handleScroll = () => {
    const section = discrepanciesSectionReference.current;
    if (section) {
      const { scrollTop, scrollHeight, clientHeight } = section;
      if (scrollTop + clientHeight >= scrollHeight - 2) {
        getMoreDiscrepancies();
      }
    }
  };

  const getMoreDiscrepancies = () => {
    if (loading || page >= maxPages) {
      return;
    }
    setVisualizeSkeleton(false);
    getDiscrepancyList(page, pageSize, search, sorting, true, body);
  };

  useEffect(() => {
    const section = discrepanciesSectionReference.current;
    if (section) {
      section.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (section) {
        section.removeEventListener("scroll", handleScroll);
      }
    };
  }, [handleScroll]);

  const handleFilters = (data) => {
    const updatedBody = buildFilterBody(data);
    setBody(updatedBody);
  };

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    setVisualizeSkeleton(true);
    getDiscrepancyList(0, pageSize, search, sorting, false, body);
  }, [search, sorting, body]);

  function generateUUID() {
    return crypto.randomUUID();
  }
  useEffect(()=>{
        localStorage.setItem("mod_id", "12");
        const moduleToAdd = {
          id: 25,
          title: "Discrepancy",
          color: "#F38A00",
          icon: "icon-success",
          path: "/supplychain/discrepancy",
          isPinned: false,
          componentKey: "Discrepancy",
          date: generateUUID(),
          isModule: false,
        };
    
        dispatch(addTab(moduleToAdd));
  } , [])
  return (
    <SortingProvider
      properties={sortingProperties}
      generalFilters={filtersDefinition}
      columnFilterProperties={sortingColumnsFilters}
      onOrderChange={(e) => {
        setSorting(e);
      }}
    >
      <section className="discrepancy">
        <div
          className="discrepancy-nav"
          style={{
            height: viewFilters ? "27%" : "20%",
          }}
        >
          <NavBar
            dataBreadCrumbs="/supplychain/discrepancy"
            moduleId={12}
            isLocalSearch
            searchActions={
              <div className="discrepancy-filters">
                <FiltersManager
                  onButtonClick={() => {
                    setViewFilters(!viewFilters);
                  }}
                ></FiltersManager>
                <SortingButton></SortingButton>
              </div>
            }
            searchInputProps={{
              type: "text",
              onTextChange: (e) => setSearch(e),
            }}
          ></NavBar>
          <FiltersAndSorting
            viewFilters={viewFilters}
            filtersParameters={orderParameter}
            onFiltersChange={handleFilters}
          ></FiltersAndSorting>
        </div>
        <div
          className="discrepancy-content"
          style={{
            height: !viewFilters ? "80%" : "70%",
          }}
          ref={discrepanciesSectionReference}
        >
          {loading && visualizeSkeletonLoading ? (
            <Skeleton height={"2.7rem"} count={10}></Skeleton>
          ) : discrepancyList.length > 0 ? (
            discrepancyList.map((e, idx) => {
              return <DiscrepancyItem data={e} key={e.id}></DiscrepancyItem>;
            })
          ) : (
            <ResultsNotFound></ResultsNotFound>
          )}
        </div>
      </section>
    </SortingProvider>
  );
};
